export default {"src":"/_next/static/media/favicon.d083dc5f.svg","height":59,"width":59,"blurWidth":0,"blurHeight":0};